import { FC, Fragment, memo, useMemo } from "react";
import { FormikHandlers } from "formik";
import { useDidMount } from "rooks";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  ResourceType,
  usePostUsersMeAccountsByTypeResourcesMutation,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";

interface NatGatewayIdFilterProps extends AutocompleteFilterBodyProps {
  accountIds?: string[];
  resourceType: ResourceType;
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const NatGatewayIdFilter: FC<NatGatewayIdFilterProps> = memo(
  ({ resourceType, accountIds, operators, filter, onChange, ...props }) => {
    const [trigger, { data, isLoading }] =
      usePostUsersMeAccountsByTypeResourcesMutation();

    useDidMount(() => {
      if (!accountIds) {
        return;
      }
      trigger({
        type: resourceType,
        body: { account_ids: accountIds },
      });
    });

    const options = useMemo(() => {
      return data?.reduce((result, item) => {
        item.resources.forEach((resource) => {
          if (resource.provider_unique_identifier) {
            result.push(resource.provider_unique_identifier);
          }
        });

        return result;
      }, [] as string[]);
    }, [data]);

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={options}
          isLoading={isLoading}
          label="NAT Gateway ID"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
        />
      </Fragment>
    );
  },
);
